module.exports = __webpack_public_path__ + "media/images/img/intaview_company/corporate_interview_logo_nri-a34e6792abcc4098daaec71e9c0db04f.png";